export const REMOTE_ID_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]$/

export const formatName = (name: string) =>
  name.replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())

export function isValidHttpsUrl(value: string): boolean {
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && url.hostname.length > 0
  } catch {
    return false
  }
}

export const brandedButtonCss = {
  backgroundColor: 'var(--chakra-colors-brand-solid)',
  color: 'var(--chakra-colors-brand-contrast)',
  _hover: { backgroundColor: 'var(--chakra-colors-brand-emphasized)' },
} as const
